import { computed } from "vue";
import { usePage } from "@inertiajs/vue3";
import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps";

// Languages still in test, each with the team feature that releases it.
const TEAM_GATED_LANGUAGES: Record<string, string> = {
    ja: "test_feature",
};

export function useLanguageAccess() {
    const page = usePage<IRhizomPageProps>();

    const teamFeatures = computed(() => page.props.team?.features ?? null);

    const isLanguageOffered = (code: string): boolean => {
        const requiredFeature = TEAM_GATED_LANGUAGES[code];

        if (requiredFeature === undefined) {
            return true;
        }

        return teamFeatures.value?.[requiredFeature] === true;
    };

    return { isLanguageOffered };
}
